import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

const PermissionProvider = ({ permission, children }) => {
  const [isGranted, setIsGranted] = useState(false)
  const permissions = useSelector((state) => state.user.permissions)

  useEffect(() => {
    if (permissions?.includes(permission)) {
      setIsGranted(true)
    }
  }, [permissions])

  return <>{isGranted ? <div>{children}</div> : null}</>
}

PermissionProvider.propTypes = {
  children: PropTypes.node,
  permission: PropTypes.string,
}

export default PermissionProvider
